export default "__VITE_ASSET__BhyrhK3C__"